<template>
  <div>
    <label>Subcategoria: </label>
    <span>
      <span
        v-if="type == 'text'"
        role="button"
        @click.prevent="$emit('resetSubcategoria')"
        ><slot></slot
      ></span>
      <div
        class="form-group d-flex"
        v-else-if="type == 'select' && resultSubcategoria"
      >
        <select
          name="subcategoria_id"
          v-if="subcategorias.length > 0"
          class="form-control"
          v-model="subcategoria_id"
          @change.prevent="$emit('setSubcategoria', $event.target.value)"
        >
          <option :value="null">Selecione</option>
          <option
            v-for="subcategoria in subcategorias"
            :key="subcategoria.id"
            :value="subcategoria.id"
          >
            {{ subcategoria.nome }}
          </option>
        </select>
        <b-btn
          v-b-tooltip.hover.right
          title="Cadastrar Subcategoria"
          variant="success"
          @click.prevent="modalShow = true"
        >
          <i class="fas fa-plus"></i>
          <span v-if="subcategorias.length == 0">Adicionar Subcategoria</span>
        </b-btn>
      </div>
    </span>
    <b-modal
      v-model="modalShow"
      persistent
      max-width="300px"
      title="Cadastrar Subcategoria"
    >
      <b-card>
        <b-card-text>
          <b-row>
            <b-col cols="12" sm="12" md="12">
              <label for="nome-categoria">Nome da Subcategoria</label>
              <b-form-input
                v-model="nome_categoria"
                label="Nome da Subcategoria"
              ></b-form-input>
            </b-col>
          </b-row>
        </b-card-text>
      </b-card>
      <template #modal-footer>
        <b-btn variant="outline-secondary" @click="modalShow = false">
          Fechar
        </b-btn>
        <b-btn
          @click.prevent="add()"
          variant="outline-secondary"
          :pressed="true"
          v-if="!!nome_categoria"
        >
          Adicionar
        </b-btn>
      </template>
    </b-modal>
  </div>
</template>
<script>
export default {
  data() {
    return {
      modalShow: false,
      subcategorias: [],
      subcategoria_id: null,
      resultSubcategoria: false,
      nome_categoria: "",
    };
  },
  props: {
    type: "",
    categoria_id: "",
  },
  watch: {
    categoria_id(newValue, oldValue) {
      this.getSubcategorias(newValue);
    },
    type(newValue) {
      if (newValue == "select") this.getSubcategorias(this.categoria_id);
    },
  },
  created() {
    this.$on("getSubcategorias", (value) => {
      this.getSubcategorias(value);
    });
  },
  mounted() {
    if (this.type == "select") {
      this.getSubcategorias(this.categoria_id);
    }
  },
  methods: {
    async add() {
      const response = await this.$api.post("tarefa/addSubcategoria", {
        parent_id: this.categoria_id,
        categoria: this.nome_categoria,
      });
      this.modalShow = false;
      this.nome_categoria = "";

      if (response.data) {
        this.subcategorias.push(response.data);
        this.subcategoria_id = response.data.id;
        this.$emit("setSubcategoria", response.data.id);
      }
    },
    async getSubcategorias(categoria_id) {
      const result = await this.$api.get(
        `tarefa/subcategorias/${categoria_id}`
      );
      this.subcategoria_id = null;
      this.resultSubcategoria = true;
      this.subcategorias = result.data;
      return result.data;
    },
  },
};
</script>